import Skeleton from "@mui/material/Skeleton";
import { ChartBlock, ChartHeader } from "./ChartStyles";

const ChartSkeleton = () => (
  <ChartBlock>
    <ChartHeader>
      <Skeleton variant="text" width={160} height={24} sx={{ bgcolor: "grey.900" }} />
      <Skeleton variant="rounded" width={220} height={30} sx={{ bgcolor: "grey.900" }} />
    </ChartHeader>
    <Skeleton variant="rounded" width="100%" height={340} sx={{ bgcolor: "grey.900" }} />
  </ChartBlock>
);

export default ChartSkeleton;
